// extracted by mini-css-extract-plugin
export default {"infoIcon":"AvailabilityDisplay_infoIcon__cUkpK","thresholdInput":"AvailabilityDisplay_thresholdInput__0CU0-","thresholdLabel":"AvailabilityDisplay_thresholdLabel__C8LBc"};